// ============================================
// Analytics - Stats Buffer (ES6)
// 통계 배치 처리 모듈
// ============================================

import { HOME_ENDPOINTS } from '../shared/api-endpoints.js';

// ============================================
// 상태 변수
// ============================================

const statsBuffer = {
  impressions: {},
  clicks: {}
};

let flushTimeout = null;
let isStatsInitialized = false;

const FLUSH_INTERVAL = 30000;
const MAX_BUFFER_SIZE = 20;

// ============================================
// 초기화
// ============================================

function initStats() {
  if (isStatsInitialized) return;
  isStatsInitialized = true;

  window.addEventListener('beforeunload', () => {
    flushStatsBeacon();
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      flushStatsBeacon();
    }
  });
}

// ============================================
// 기록 함수
// ============================================

export function recordImpression(publishedId) {
  if (!publishedId) return;
  initStats();
  statsBuffer.impressions[publishedId] = (statsBuffer.impressions[publishedId] || 0) + 1;
  scheduleStatsFlush();
}

export function recordClick(publishedId) {
  if (!publishedId) return;
  initStats();
  statsBuffer.clicks[publishedId] = (statsBuffer.clicks[publishedId] || 0) + 1;
  scheduleStatsFlush();
}

// ============================================
// 플러시 함수
// ============================================

function scheduleStatsFlush() {
  const totalCount = Object.keys(statsBuffer.impressions).length +
                     Object.keys(statsBuffer.clicks).length;

  if (totalCount >= MAX_BUFFER_SIZE) {
    flushStats();
    return;
  }

  if (!flushTimeout) {
    flushTimeout = setTimeout(flushStats, FLUSH_INTERVAL);
  }
}

export async function flushStats() {
  clearTimeout(flushTimeout);
  flushTimeout = null;

  const data = {
    impressions: { ...statsBuffer.impressions },
    clicks: { ...statsBuffer.clicks }
  };

  statsBuffer.impressions = {};
  statsBuffer.clicks = {};

  if (!Object.keys(data.impressions).length && !Object.keys(data.clicks).length) {
    return;
  }

  try {
    await fetch(HOME_ENDPOINTS.recordStatsBatch, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
  } catch (e) {
    console.warn('Stats flush failed:', e);
  }
}

function flushStatsBeacon() {
  const data = {
    impressions: statsBuffer.impressions,
    clicks: statsBuffer.clicks
  };

  if (!Object.keys(data.impressions).length && !Object.keys(data.clicks).length) {
    return;
  }

  navigator.sendBeacon(
    HOME_ENDPOINTS.recordStatsBatch,
    JSON.stringify(data)
  );

  statsBuffer.impressions = {};
  statsBuffer.clicks = {};
}

// ============================================
// StatsBuffer 객체 (하위 호환성)
// ============================================

export const StatsBuffer = {
  recordImpression,
  recordClick,
  flush: flushStats
};

// window 노출 (하위 호환성)
window.StatsBuffer = StatsBuffer;
